/* eslint-disable jira/filename-case */
import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return (
			expVal(
				'thor_colourful_single_select_milestone2_experiment',
				'isColorfulSingleSelectEnabled',
				false,
			) &&
			expVal(
				'thor_colourful_single_select_fields_experiment',
				'isColorfulSingleSelectEnabled',
				false,
			)
		);
	},
};
